// extracted by mini-css-extract-plugin
export default {"container":"Skeleton_container__AdZTK","skeleton":"Skeleton_skeleton__WxnXJ","circle":"Skeleton_circle__cXswh"};